import { useEnvStore, useProjectTheme } from 'store'
import { PLATFORM_CONFIG, PlatformKey, PlatformName } from 'platform-config'
import './FooterView.scss'
import { Email, TG } from './Icons'
import { useI18n } from 'i18n-utils'
import { PageRoutes } from 'cloud-computing-power/constants/PageRoutes.ts'
import { ElPopover } from 'element-plus'
import classNames from 'classnames'

export const FooterViewHashSpace = defineComponent({
  setup() {
    const themeStore = useProjectTheme()
    const theme = computed(() => themeStore.theme)
    const envStore = useEnvStore()
    const { t } = useI18n()
    const route = useRoute()

    const getCopyRight = () => {
      return `© ${new Date().getFullYear()} ${PLATFORM_CONFIG.platformName}. All rights reserved.`
    }
    const tgContact = computed(() => {
      if (!envStore.config?.qrcode?.oriUrl) return null
      const tgName = envStore.config.qrcode.oriUrl.split('/')[envStore.config.qrcode.oriUrl.split('/').length - 1]
      return {
        onClick: () => openLink(envStore.config.qrcode.oriUrl),
        name: `@${tgName}`,
        qrcodeUrl: envStore.config.qrcode.url,
      }
    })
    const openLink = (url: string) => {
      window.open(url, '_black')
    }

    const footerLogoWidth = computed(() => {
      return PlatformKey === 'bge' ? 92 : 200
    })

    return () => (
      <div class={classNames('cloud-computing-power-footer-view-layout', { 'platform-bge': PlatformKey === 'bge' }, { 'cloud-computing-power-detail': route.path.includes(PageRoutes.GoodDetail) })}>
        <div class="page-container footer-container">
          <div class={'page-container-content'}>
            <div class="bge-footer-wrap">
              <img width={footerLogoWidth.value} src={theme.value.footerLogo} alt={PlatformName} />
              <div class="bge-content">
                <div class="link" onClick={() => openLink(PageRoutes.ServiceAgreement)}>
                  {t('服务协议')}
                </div>
                <div class="link" onClick={() => openLink(PageRoutes.PrivacyPolicy)}>
                  {t('隐私协议')}
                </div>
                <div class="link" onClick={() => openLink(PageRoutes.Disclaimer)}>
                  {t('免责声明')}
                </div>
              </div>
              <div class={'contacts'}>
                <a href="mailto:support@cyberleap.us" class={'email'}>
                  <Email />
                  support@cyberleap.us
                </a>

                {tgContact.value && (
                  <ElPopover effect="light" placement="bottom-end" showArrow={true} offset={0} trigger={'hover'} teleported={false} width={'auto'}>
                    {{
                      reference: () => (
                        <a href="#" onClick={tgContact.value?.onClick} class={'email'}>
                          <TG />
                          {tgContact.value?.name}
                        </a>
                      ),
                      default: () => (
                        <div class={'qr-code-container'}>
                          <img width={128} src={tgContact.value?.qrcodeUrl} alt="" />
                        </div>
                      ),
                    }}
                  </ElPopover>
                )}
              </div>
            </div>
            <div class="copy-right">{getCopyRight()}</div>
          </div>
        </div>
      </div>
    )
  },
})
